import {STATES} from "./states";
import {CONSTANTS} from "./constants";
import {TranslationsManager} from "../utils/localisationManager";

export const HelperFunctions = {
    doApplyHandlerToElem: (elem, handler, event) => {
        const $elem = $(elem);
        $elem.on(event, () => {
            handler();
        })

        return $elem;
    },
    doSaveCartBillingInfo: () => {
    },
    doSetCartBillingInfo: () => {
    },
    getCartBillingInfo: () => {
    },
    waitForElement: (selector) => {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    },
    outerHTML: (htmlNode) => {
        return (
            htmlNode.outerHTML || new XMLSerializer().serializeToString(htmlNode)
        );
    },
    doCloseAllModalOverlays: () => {
        $('body').removeClass(`
        user-action-visible
        basket-sidePopup
        cart-window-visible
        search-window-visible
        login-window-visible
        modal-chart-visible
        `)
    },
    showSelectedShippingCart: () => {
    },
    onBasketEmpty: () => {
    },
    doAppendCartRelatedProducts: (products, isCartEmpty) => {
    },
    doAllowOneEmit: function (stateName) {
        if (STATES[stateName]) {
            STATES[stateName] = false;
            return true;
        } else {
            setTimeout(() => {
                STATES[stateName] = true;
            }, 3000);
            return false;
        }
    },
    // TODO: FETCH PRODUCTS FROM PRODUCTS
    doFetchProductsFromHomePage: async () => {
    },
    doReplaceImageSourceAttributes: (image, from, to) => {
        const imgDataSrc =$(image).attr("data-src");
        const imgSrc = $(image).attr("src");

        if(!imgDataSrc && !imgSrc) {
            return;
        }

        if(!imgDataSrc) {
            $(image).attr(
                "data-src",
                imgSrc.replace(from, to)
            );
        } else {
            $(image).attr(
                "data-src",
                imgDataSrc.replace(from, to)
            );
        }
        if(imgSrc.includes('data:image')) {
            $(image).attr(
                "src",
                imgDataSrc.replace(from, to)
            );
        } else {
            $(image).attr(
                "src",
                imgSrc.replace(from, to)
            );
        }
    },
    doReturnVariationsImageByProdId: (prodId) => {
        return CONSTANTS.images[prodId] || null;
    },
    doStyleBreadcrumbOnProduct: () => {
    },
    doReplaceProductMainImageSrc: (htmlElem) => {
        const origSetAttrFunc = htmlElem.setAttribute.bind(htmlElem);

        htmlElem.setAttribute = (attrName, attrValue) => {
            if((attrName === 'src' || attrName === 'data-src') && attrValue.includes('/big/')) {
                attrValue = attrValue.replace('/big/', '/orig/');
            }

            origSetAttrFunc(attrName, attrValue);
        }
    },
    doAppendSizeChartWrapper: () => {
        $(`<div class="chart-wrapper">${TranslationsManager.doGetStringByLang('FOR_MORE_INFORMATION')} <a class="modal-chart-trigger" href="#">${TranslationsManager.doGetStringByLang('SIZE_CHART')}</a></div>`)
            .insertAfter('.p-info-wrapper .detail-parameters');
    }
}
